/**
*  料金シミュレーター
*
*  通所リハビリテーション
*
*  @since 2019.9.24
*  @use jQuery
*/




/**
*  Variables
*
*  自己負担となる利用金額
*/

const array_daycare = {
  /* 介護度に応じたサービス料 */
  kaigo:
  [
    // 介護度 1 : [ 1割, 2割, 3割 ]
    {
      twoToThree: [ 417, 827, 1241 ],
      sixToSeven: [ 773, 1545, 2318]
      
    },
    // 介護度 2 : [ 1割, 2割, 3割 ]
    {
      twoToThree: [ 475, 949, 1423 ],
      sixToSeven: [ 962, 1924, 2886]
      
    },
    // 介護度 3 : [ 1割, 2割, 3割 ]
    {
      twoToThree: [ 538, 1075, 1613 ],
      sixToSeven: [ 1060, 2120, 3180]
      
    },
    // 介護度 4 : [ 1割, 2割, 3割 ]
    {
      twoToThree: [ 600, 1199, 1799 ],
      sixToSeven: [ 1229, 2457, 3685]
      
    },
    // 介護度 5 : [ 1割, 2割, 3割 ]
    {
      twoToThree: [ 662, 1323, 1985 ],
      sixToSeven: [ 1394, 2788, 4182]
      
    }
  ],
  // １週の利用日数 [ 週1日, 週2日, 週3日 ]
  week: [ 4, 8, 12 ]
}

// '1週間あたりの利用回数' の OPTION 項目の配列
const weekOptionArray = [
  '選択してください',
  '週1日',
  '週2日',
  '週3日'
];

/**
*  function
*  動作
*/

// 通所リハビリテーション
$( calcBtn.daycare ).on('click', function(e){
  e.preventDefault();

  const formData = $( currentForm.daycare ).serializeArray();
  const selectVal = selectCheck( currentForm.daycare, formData );
  let daysExpense, serviceExpense;

  // すべて選択されていれば flag = true
  if( selectVal ){
    /* 計算処理開始 */
    // 1日の利用時間に応じて居住費を設定
    switch( parseInt( selectVal.days, 10 ) )
    {

      // 2～3時間
      case 1:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].twoToThree[ selectVal.futan ];
      break;

      // 6～7時間
      case 2:
        daysExpense = array_daycare.kaigo[ selectVal.kaigo ].sixToSeven[ selectVal.futan ];
      break;

      // default
      default:
        return;
      break;
    }

    // 結果を出して表示する
    const result = parseInt( daysExpense, 10) * parseInt( selectVal.weeks, 10);
    $( resultElm.daycare ).html( numberWithComma.format( result ) );
  } // end of 計算処理開始
return;
});

// '介護度' を変更したとき '1週間あたりの利用回数' の内容を書き換える
$( currentForm.daycare + ' [name="kaigo"]' ).on('change', function(){
  const kaigoValue = this.selectedIndex;
  const weekOption = this.form.weeks;

  // if ( kaigoValue === 6 ) {
  //   weekOption.textContent = null;
  //   weekOption.options[0] = new Option( weekOptionArray[0], '' );
  //   weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
  // } else if ( kaigoValue === 7 ) {
  //   weekOption.textContent = null;
  //   weekOption.options[0] = new Option( weekOptionArray[0], '' );
  //   weekOption.options[1] = new Option( weekOptionArray[2], array_daycare.week[1] );
  // } else {
  //   weekOption.textContent = null;
  //   weekOption.options[0] = new Option( weekOptionArray[0], '' );
  //   weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
  //   weekOption.options[2] = new Option( weekOptionArray[2], array_daycare.week[1] );
  //   weekOption.options[3] = new Option( weekOptionArray[3], array_daycare.week[2] );
  // }

  weekOption.textContent = null;
  weekOption.options[0] = new Option( weekOptionArray[0], '' );
  weekOption.options[1] = new Option( weekOptionArray[1], array_daycare.week[0] );
  weekOption.options[2] = new Option( weekOptionArray[2], array_daycare.week[1] );
  weekOption.options[3] = new Option( weekOptionArray[3], array_daycare.week[2] );
});
